module.exports = __webpack_public_path__ + "static/media/up_integration_bg_mobile.b199ff33.png";